export class GcpNetworkingSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcPeering",
            "baseName": "vpcPeering",
            "type": "GcpVpcPeering",
            "format": ""
        },
        {
            "name": "privateServiceConnects",
            "baseName": "privateServiceConnects",
            "type": "Array<PscEndpoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpNetworkingSettings.attributeTypeMap;
    }
    constructor() {
    }
}
